import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth';
import App, { PRERENDERED_PAGES } from './App';
import { initTheme } from './theme';
import './styles.css';

initTheme();

const rootEl = document.getElementById('root')!;
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// The prerendered pages (see entry-server.tsx and scripts/prerender.mjs)
// arrive with real markup in #root, so they're hydrated rather than
// replaced, once their page's chunk is in (lazyPage.tsx): a page still
// loading as hydration starts can lose that markup to its fallback. Every
// other route
// (/claim, /oauth/authorize, /:alias/*) is served the plain, empty-#root
// shell and mounts fresh, loading its page as it goes.
if (rootEl.hasChildNodes()) {
  const page = PRERENDERED_PAGES[location.pathname.replace(/(.)\/$/, '$1')];
  (page ? page.preload() : Promise.resolve()).then(() => ReactDOM.hydrateRoot(rootEl, app));
} else {
  ReactDOM.createRoot(rootEl).render(app);
}
